import { render, staticRenderFns } from "./Layers.vue?vue&type=template&id=ddd53a3a&scoped=true&"
import script from "./Layers.vue?vue&type=script&lang=js&"
export * from "./Layers.vue?vue&type=script&lang=js&"
import style0 from "./Layers.vue?vue&type=style&index=0&id=ddd53a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd53a3a",
  null
  
)

export default component.exports